import HttpClient from './HttpClient';
const API_BASE_URL = process.env.REACT_APP_API_URL

// Mapping from frontend module keys to backend controller names
const ENDPOINT_MAPPING = {
  coa: "ChartOfAccounts",
  vendors: "Vendor",
  customers: "Customer",
  vendor_bills: "VendorBill",
  customer_invoices: "CustomerInvoice",
  vendor_payments: "VendorPayment",
  customer_receipts: "CustomerReceipt",
  credit_notes: "CreditNotes",
  debit_notes: "DebitNotes",
  fixed_assets: "FixedAsset",
  journal_transactions: "JournalTransaction",
  bank_reconciliation: "BankReconciliations",
  depreciation_schedule: "DepreciationSchedule",
  asset_disposal: "AssetDisposal",
  asset_categories: "AssetCategory",
  inv_products: "Product",
  inv_transfer: "InventoryTransfer",
  inv_issuance: "InventoryIssuance",
  inv_receipt: "InventoryReceipt",
  inv_warehouse: "Warehouse",
  inv_bom: "BillOfMaterial",
  hrm_employee_profile: "Employee",
  hrm_benefits: "BenefitDeduction",
  hrm_salary_structure: "SalaryStructure",
  hrm_kpis: "KPI",
  config_journal: "Journal",
  config_fin_dims: "FinancialDimension",
};

// A standard class for API responses
class ApiResponse {
  constructor(data) {
    this.success = data?.success ?? true;
    this.message = data?.message || "";
    this.data = data?.data || null;
    this.errors = data?.errors || [];
    this.totalCount = data?.totalCount || 0;
  }
}


// Generic service for CRUD operations
class CrudService {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }
  getAll(params = {}) {
    return HttpClient.get(`${this.endpoint}`, params);
  }
  getById(id) {
    return HttpClient.get(`${this.endpoint}/${id}`);
  }
  create(data) {
    return HttpClient.post(`${this.endpoint}`, data);
  }
  update(id, data) {
    return HttpClient.put(`${this.endpoint}/${id}`, data);
  }
  delete(id) {
    return HttpClient.delete(`${this.endpoint}/delete/${id}`);
  }

  getNextNumber(companyId) {
    console.log("enpoint f", `${this.endpoint}/GetNextNumber`);
    return HttpClient.get(`${this.endpoint}/GetNextNumber`, { companyId });
  }
}

// Service specifically for fetching the dynamic module UI configurations
class ModuleConfigurationService {
  getModuleConfiguration(moduleKey) {
    return HttpClient.get(`DynamicModule/config/${moduleKey}`);
  }
}

// The factory creates a generic service instance for a given controller route
class ServiceFactory {
  static services = {};

  static getService(moduleKey) {
    // Map the frontend module key to the backend controller name
    const controllerRoute = ENDPOINT_MAPPING[moduleKey] || moduleKey;

    if (!this.services[moduleKey]) {
      this.services[moduleKey] = new CrudService(controllerRoute);
    }
    return this.services[moduleKey];
  }
}

// A single instance of the config service to be used everywhere
export const moduleConfigService = new ModuleConfigurationService();

// A generic function for fetching data for dropdowns
export const getDataSource = (url) => {
  return HttpClient.get(`${url.replace("api/", "")}`);
};

export default ServiceFactory;
